import React, { useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { nextCampaignService } from '../../../services/next';

const { Text } = Typography;

const STATUS_OPTIONS = [
  { label: 'Kích hoạt', value: 1 },
  { label: 'Tạm dừng', value: 0 },
];

const TYPE_OPTIONS = [
  { label: 'Thường', value: 1 },
  { label: 'Giới thiệu', value: 2 },
];

const QuanLyChienDich = () => {
  const columns = useMemo(() => [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'TÊN CHIẾN DỊCH', dataIndex: 'title', key: 'title', width: 250, render: (t) => <Text strong>{t}</Text> },
    { title: 'MÔ TẢ', dataIndex: 'description', key: 'description' },
    { title: 'LOẠI', dataIndex: 'type', key: 'type', width: 100, render: (t) => {
        const option = TYPE_OPTIONS.find(o => o.value === t);
        return option ? option.label : t;
    } },
    { 
        title: 'TRẠNG THÁI', 
        dataIndex: 'status', 
        key: 'status', 
        width: 120, 
        render: (s) => { 
            const map = { 0: ['default','TẠM DỪNG'], 1: ['green','KÍCH HOẠT'] }; 
            const [c,l] = map[s] || ['default', s]; 
            return <Tag color={c}>{l}</Tag>; 
        } 
    },
    { title: 'THỜI GIAN BẮT ĐẦU', dataIndex: 'start_time', key: 'start_time', width: 160, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
    { title: 'THỜI GIAN KẾT THÚC', dataIndex: 'end_time', key: 'end_time', width: 160, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
  ], []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tên chiến dịch', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tên chiến dịch!' }] },
    // Select không allowClear nên luôn có giá trị, nhưng vẫn khai required để hiện dấu * —
    // validator API đã nhận và giới hạn type ∈ {1, 2} trong cùng đợt này (QA-06).
    { name: 'type', label: 'Loại chiến dịch', type: 'select', options: TYPE_OPTIONS, defaultValue: 1, rules: [{ required: true, message: 'Vui lòng chọn loại chiến dịch!' }] },
    { name: 'description', label: 'Mô tả', type: 'textarea', propsInput: { rows: 4 } },
    { name: 'start_time', label: 'Thời gian bắt đầu', type: 'date', format: 'DD/MM/YYYY HH:mm:ss', propsInput: { showTime: true, format: 'DD/MM/YYYY HH:mm:ss' } },
    {
      name: 'end_time',
      label: 'Thời gian kết thúc',
      type: 'date',
      format: 'DD/MM/YYYY HH:mm:ss',
      propsInput: { showTime: true, format: 'DD/MM/YYYY HH:mm:ss' },
      // Kiểm lại mỗi khi ô bắt đầu đổi; API cũng chặn cùng điều kiện này
      propsFormItem: { dependencies: ['start_time'] },
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            const start = getFieldValue('start_time');
            if (!value || !start || !dayjs(value).isBefore(dayjs(start))) return Promise.resolve();
            return Promise.reject(new Error('Thời gian kết thúc phải sau thời gian bắt đầu'));
          },
        }),
      ],
    },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], []);

  const filterFields = useMemo(() => [
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả', value: '' },
        ...STATUS_OPTIONS,
      ],
    },
  ], []);

  return (
    <CrudPage
      title="QUẢN LÝ CHIẾN DỊCH"
      subTitle="Quản lý danh sách chiến dịch"
      itemsName="Chiến dịch"
      queryKey="nextCampaignList"
      service={nextCampaignService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchFields={[
        { label: 'Tên chiến dịch', value: 'title' },
        { label: 'Mô tả', value: 'description' },
      ]}
      searchPlaceholder="Tìm kiếm..."
      addButtonLabel="Thêm chiến dịch"
      formConfig={{ width: 600 }}
    />
  );
};

export default QuanLyChienDich;
